import React, { useState, useCallback, useEffect, useMemo } from 'react'
import { Icon } from 'meinian-package/src/component'
import classNames from 'classnames'
import styles from './index.module.less'

export default ({
  menu = [],
  disabled,
  isPoint = false,
  itemHeight = 38,
  value,
  className, isIcon = true, style, color, onParentClick, menuItemNameWidth }) => {
  const [showValue, setShowValue] = useState(menu[0]?.id) // 默认展开第一个
  useEffect(() => {
    setShowValue(menu[0]?.id)
  }, [menu])
  const onMenuParent = (_value) => {
    if (lengthSize1) {
      return
    }
    if (showValue !== _value) {
      setShowValue(_value)
    } else {
      _value ? setShowValue(null) : setShowValue(_value)
    }
  }

  const getPointBg = useCallback((index) => {
    if (color) {
      return { backgroundColor: color[(index) % 13] }
    }
    return {}
  }, [color])

  const lengthSize1 = useMemo(() => menu.length === 1, [menu.length])
  const _isIcon = useMemo(() => {
    if (lengthSize1) {
      return false
    }
    return isIcon
  }, [lengthSize1, isIcon])

  return (<div className={classNames(styles['meinian-nest-menu'], className)} style={style}>
    {
        menu?.map((parent, index) => <div key={index}>
          <div
            className={classNames('meinian-nest-menu-parent', { active: value === parent.id, disabled })}
            onClick={() => {
              parent?.children?.length && onMenuParent(parent.id)
              onParentClick?.({ ...parent, color: color[(index) % 13] })
            }}
          >
            <div className="meinian-nest-menu-parent-name">
              {isPoint && <span className="meinian-nest-menu-parent-name-point" style={{ ...getPointBg(index) }} />}
              <span className="name" style={{ width: menuItemNameWidth }}>{parent.name}</span>
            </div>
            <div className="meinian-nest-menu-parent-number">
              <span>{parent.value}</span>
              {
                (parent.percentage || parent.percentage === 0) && <>
                  <span className="meinian-nest-menu-number-line" />
                  <span>{parent.percentage}%</span>
                </>
              }
              <span style={{ marginRight: `${!parent?.children?.length ? '8px' : '0px'}` }} />
              {
              (parent?.children?.length && _isIcon) ? <div className="meinian-nest-menu-parent-icon">{parent.id === showValue ? <Icon type="m-Vxing_shang" /> : <Icon type="m-Vxing_xia" /> }</div> : null
            }
            </div>
          </div>
          {
            parent?.children?.length ? <div
              className={classNames('meinian-nest-menu-children')}
              style={{ height: parent.id === showValue ? parent.children.length * itemHeight : 0 }}
            >
              {parent?.children.map((menuItem, i) => <div key={i} className="meinian-nest-menu-children-item">
                <div className="meinian-nest-menu-children-item-name">
                  {isPoint && <span className="meinian-nest-menu-parent-name-point" style={{ ...getPointBg(i + menu.length) }} />}
                  <span className="name" style={{ width: menuItemNameWidth }}>{menuItem.name}</span>
                </div>
                <div className="meinian-nest-menu-children-item-number">
                  <span>{menuItem.value}</span>
                  {
                    (menuItem.percentage || menuItem.percentage === 0) && <>
                      <span className="meinian-nest-menu-number-line" />
                      <span>{menuItem.percentage}%</span>
                    </>
                  }
                </div>
              </div>)}
            </div> : null
          }
        </div>)
    }
  </div>)
}
